var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui form"},[_c('setup',{ref:"setup",attrs:{"setting":_vm.setting,"index":_vm.index,"integration_files":_vm.integration_files},on:{"remove":_vm.remove_setting}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }